import { InputProps as AntInputProps, InputRef } from 'antd';
import { TestProps } from 'core/utils/testTypes';
import { ChangeEventHandler, forwardRef } from 'react';
import { StyledInput } from './Input.styles';

export interface InputProps extends AntInputProps, TestProps {
    addonAfter?: React.ReactNode;
    prefix?: React.ReactNode;
    suffix?: React.ReactNode;
    allowClear?: boolean;
    bordered?: boolean;
    placeholder?: string;
    id?: string;
    value?: string;
    onChange?: ChangeEventHandler<HTMLInputElement>;
    onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
    disabled?: boolean;
    style?: React.CSSProperties;
    maxLength?: number;
}

const AInput = forwardRef<InputRef, InputProps>(({ className, type, ...rest }, ref) =>
    type === 'password' ? (
        <StyledInput.Password {...rest} ref={ref} className={className} />
    ) : (
        <StyledInput {...rest} ref={ref} className={className} />
    )
);
export default AInput;
